<template>
<div>
    <h4>APÉNDICES</h4>
    <v-navigation-drawer permanent left style="z-index:0 !important; margin-top: -6px; height: 750px">
        <br />
        <v-list dense class="pt-0 ">

            <v-list-group v-for="(grupo, index) in grupos" :key="'grupo'+index" v-show="(mve== 1 && grupo.mve == 1) || (sa31 == 1 && grupo.sa31 == 1) || (view_trafico==1 && grupo.trafico == 1) || (mve== 0 && sa31 == 0 && grupo.sa31 == 0 && grupo.trafico == 0)" no-action :prepend-icon="grupo.icon" :value="grupo.id==grupoActivo">
                <template v-slot:activator>
                    <v-list-item-title>{{grupo.nombre}}</v-list-item-title>
                </template>

                <v-list-item v-for="(item, index2) in getItemsGrupo(grupo.id)" :key="'link'+grupo.id+'-'+index2" @click="render(item.url)" v-show="(item.trafico==undefined || (item.trafico!=undefined && traficoActivo==item.trafico))" :class=" {'#e0e0e0 secondary lighten-1': url_active.indexOf(item.url) > -1}">
                    <v-list-item-content>
                        - {{ item.title }}
                    </v-list-item-content>
                </v-list-item>

                <v-list-group v-for="(subgrupo, indexs) in subgrupos" :key="'subgrupo'+indexs" v-show="(subgrupo.grupo == grupo.id && ((subgrupo.trafico==1 && traficoActivo==1) || subgrupo.trafico== 0))" no-action sub-group :value="subgrupo.id==subgrupoActivo">
                    <template v-slot:activator>
                        <v-list-item-title>{{subgrupo.nombre}}</v-list-item-title>
                    </template>

                    <v-list-item v-for="(items, index2s) in getItemsSubgrupo(subgrupo.id)" :key="'sublink'+subgrupo.id+'-'+index2s" @click="render(items.url)" v-show="(items.trafico==undefined || (items.trafico!=undefined && traficoActivo==items.trafico))" :class=" {'#e0e0e0 secondary lighten-1': url_active.indexOf(items.url) > -1}">
                        <v-list-item-content>
                            - {{ items.title }}
                        </v-list-item-content>
                    </v-list-item>

                </v-list-group>
            </v-list-group>
        </v-list>

    </v-navigation-drawer>
</div>
</template>

<script>
export default {
    props: {},
    data: () => ({
        fab: false,
        name: "Menu Lateral Layout",
        busqueda: "",
        grupoActivo: 1,
        subgrupoActivo: '',
        traficoActivo: 0,
        grupos: [{
                id: 1,
                nombre: "Econnect",
                icon: "domain",
                trafico: 0,
                sa31: 0,
                mve:0
            },
            {
                id: 5,
                nombre: "Activo Fijo",
                icon: "list",
                trafico: 0,
                sa31: 0,
                mve: 0
            },
            {
                id: 2,
                nombre: "Anexo 22",
                icon: "menu_book",
                trafico: 0,
                sa31: 0,
                mve: 0
            },
            {
                id: 6,
                nombre: "Matriz RRNA",
                icon: "view_list",
                trafico: 0,
                sa31: 0,
                mve: 0
            },
            {
                id: 3,
                nombre: "Gestión Embarques",
                icon: "flight",
                trafico: 1,
                sa31: 0,
                mve: 0
            },
            {
                id: 4,
                nombre: "Solución A31",
                icon: "book",
                trafico:0,
                sa31: 1,
                mve: 0
            },

            {
                 id: 7,
                nombre: "MVs",
                icon: "book",
                trafico:0,
                sa31: 0,
                mve: 1
            },
        ],
        itemsOrdered: [],
        items: [{
                nombre_anterior: "1. Medios de Transporte",
                title: "Medios de Transporte",
                icon: "arrow_right",
                url: "/apendices/01",
                id_grupo: 2
            },
            {
                nombre_anterior: "2. Unidades de Medida",
                title: "Unidades de Medida",
                icon: "arrow_right",
                url: "/apendices/02",
                id_grupo: 1
            },
            {
                nombre_anterior: "3. Tipo de Contenedores",
                title: "Tipos de Contenedores",
                icon: "arrow_right",
                url: "/apendices/03",
                id_grupo: 2
            },
            {
                nombre_anterior: "4. Claves de Métodos de Valoración",
                title: "Claves de Métodos de Valoración",
                icon: "arrow_right",
                url: "/apendices/04",
                id_grupo: 2
            },
            {
                nombre_anterior: "5. Formas de Pago",
                title: "Formas de Pago",
                icon: "arrow_right",
                url: "/apendices/05",
                id_grupo: 2
            },
            {
                nombre_anterior: "6. Destinos de Mercancías",
                title: "Destinos de Mercancías",
                icon: "arrow_right",
                url: "/apendices/06",
                id_grupo: 2
            },
            {
                nombre_anterior: "7. Regímenes",
                title: "Regímenes",
                icon: "arrow_right",
                url: "/apendices/07",
                id_grupo: 2
            },
            /*{ //JEMM(19-05-2020): Lourdes solicitó quitarlo del Listado
                nombre_anterior: "8. Tipos de Tasas",
                title: "Tipos de Tasas",
                icon: "arrow_right",
                url: "/apendices/08"
            },
            {
                nombre_anterior: "9. Tipos de Certificación de Pago",
                title: "Tipos de Certificación de Pago",
                icon: "arrow_right",
                url: "/apendices/09"
            },*/
            {
                nombre_anterior: "10. Claves de Moneda",
                title: "Claves de Moneda",
                icon: "arrow_right",
                url: "/apendices/10",
                id_grupo: 1
            },
            {
                nombre_anterior: "11. Recintos Fiscalizados Estratégicos",
                title: "Recintos Fiscalizados Estratégicos",
                icon: "arrow_right",
                url: "/apendices/11",
                id_grupo: 2
            },
            {
                nombre_anterior: "12. Regulaciones y Restricciones",
                title: "Regulaciones y Restricciones",
                icon: "arrow_right",
                url: "/apendices/12",
                id_grupo: 2
            },
            {
                nombre_anterior: "13. Claves de Pedimento",
                title: "Claves de Pedimento",
                icon: "arrow_right",
                url: "/apendices/13",
                id_grupo: 2
            },
            {
                nombre_anterior: "14. Tipos de Contribución",
                title: "Tipos de Contribución",
                icon: "arrow_right",
                url: "/apendices/14",
                id_grupo: 2
            },
            {
                nombre_anterior: "15. Términos de Facturación",
                title: "Términos de Facturación",
                icon: "arrow_right",
                url: "/apendices/15",
                id_grupo: 1,
                trafico: 1
            },
            {
                nombre_anterior: "16. Identificadores",
                title: "Identificadores",
                icon: "arrow_right",
                url: "/apendices/16",
                id_grupo: 2
            },
            {
                nombre_anterior: "17. Claves de Países",
                title: "Claves de Países",
                icon: "arrow_right",
                url: "/apendices/17",
                id_grupo: 2
            },
            {
                nombre_anterior: "18. Recintos Fiscalizados",
                title: "Recintos Fiscalizados",
                icon: "arrow_right",
                url: "/apendices/18",
                id_grupo: 2
            },
            {
                nombre_anterior: "19. Secciones Aduaneras",
                title: "Secciones Aduaneras",
                icon: "arrow_right",
                url: "/apendices/19",
                id_grupo: 2
            },
            {
                nombre_anterior: "20. Tipo de Embarques",
                title: "Tipos de Embarques",
                icon: "arrow_right",
                url: "/apendices/20",
                id_grupo: 3,
                trafico: 1 //Solo visible si tiene permisos de Gestión de Embarques(Tráficos)
            },
            {
                nombre_anterior: "21. Tipo de Operaciones",
                title: "Tipos de Operaciones",
                icon: "arrow_right",
                url: "/apendices/21",
                id_grupo: 3,
                trafico: 1
            },
            {
                nombre_anterior: "22. Claves de Estados",
                title: "Claves de Estados",
                icon: "arrow_right",
                url: "/apendices/22",
                id_grupo: 1
            },
            {
                nombre_anterior: "23. Claves de Municipios",
                title: "Claves de Municipios",
                icon: "arrow_right",
                url: "/apendices/23",
                id_grupo: 1
            },
            {
                nombre_anterior: "24. Claves de Ciudades",
                title: "Claves de Ciudades",
                icon: "arrow_right",
                url: "/apendices/24",
                id_grupo: 1
            },
            {
                nombre_anterior: "25. Tipos de Documentos",
                title: "Tipos de Documentos - EEA",
                icon: "arrow_right",
                url: "/apendices/25",
                id_grupo: 3,
                trafico: 1
            },
            {
                nombre_anterior: "25. Tipos de Documentos",
                title: "Tipos de Documentos",
                icon: "arrow_right",
                url: "/apendices/25",
                id_grupo: 1,
            },
            {
                nombre_anterior: "26. Relación Regímenes",
                title: "Relación Regímenes",
                icon: "arrow_right",
                url: "/apendices/26",
                id_grupo: 2
            },
            {
                nombre_anterior: "",
                title: "Tipos Proveedores Logísticos",
                icon: "arrow_right",
                url: "/apendices/29",
                id_grupo: 1
            },
            {
                nombre_anterior: "",
                title: "Importadores-Exportadores",
                icon: "arrow_right",
                url: "/apendices/importadores",
                id_grupo: 1
            },
            {
                nombre_anterior: "",
                title: "Transportistas",
                icon: "arrow_right",
                url: "/apendices/ap_transportistas",
                id_grupo: 1
            },
            {
                nombre_anterior: "",
                title: "Bancos",
                icon: "arrow_right",
                url: "/apendices/bancos",
                id_grupo: 1
            },
            {
                nombre_anterior: "",
                title: "Destinos Aduaneros",
                icon: "arrow_right",
                url: "/apendices/30",
                id_grupo: 4
            },
            {
                nombre_anterior: "",
                title: "Tipo de Informes",
                icon: "arrow_right",
                url: "/apendices/31",
                id_grupo: 4
            },
            {
                nombre_anterior: "",
                title: "Períodos Asociados",
                icon: "arrow_right",
                url: "/apendices/32",
                id_grupo: 4
            },
            {
                nombre_anterior: "",
                title: "Claves Operación Cargo",
                icon: "arrow_right",
                url: "/apendices/33",
                id_grupo: 4
            },
            {
                nombre_anterior: "",
                title: "Regímen de Operación",
                icon: "arrow_right",
                url: "/apendices/34",
                id_grupo: 4
            },
            {
                nombre_anterior: "",
                title: "Tipos Certificación",
                icon: "arrow_right",
                url: "/apendices/35",
                id_grupo: 4
            },
            {
                nombre_anterior: "",
                title: "Subnivel de Régimen de Operación",
                icon: "arrow_right",
                url: "/apendices/certificaciones",
                id_grupo: 4
            },
            {
                nombre_anterior: "27. Identificadores Activo Fijo",
                title: "Identificadores Activo Fijo",
                icon: "arrow_right",
                url: "/apendices/27",
                id_grupo: 5
            },
            {
                nombre_anterior: "",
                title: "Matriz RNNA",
                icon: "arrow_right",
                url: "/apendices/matriz_rnna",
                id_grupo: 6
            },
           
             {
                nombre_anterior: "",
                title: "01. Formas de Pago",
                icon: "arrow_right",
                url: "/apendices/39",
                id_grupo: 7
            },

             
             {
                nombre_anterior: "",
                title: "02. Metodos de Valoración",
                icon: "arrow_right",
                url: "/apendices/42",
                id_grupo: 7
            },
             {
                nombre_anterior: "",
                title: "03. Incrementables",
                icon: "arrow_right",
                url: "/apendices/41",
                id_grupo: 7
            },
            {
                nombre_anterior: "",
                title: "04. Decrementables",
                icon: "arrow_right",
                url: "/apendices/38",
                id_grupo: 7
            },
             {
                nombre_anterior: "",
                title: "05. Tipos de Figura",
                icon: "arrow_right",
                url: "/apendices/43",
                id_grupo: 7
            },
             {
                nombre_anterior: "06. Tipos de Documentos",
                title: "Tipos de Documentos - EEA",
                icon: "arrow_right",
                url: "/apendices/25",
                id_grupo: 7,
            },
             {
                nombre_anterior: "",
                title: "07. Claves de Moneda",
                icon: "arrow_right",
                url: "/apendices/10",
                id_grupo: 7
            },
            
            {
                nombre_anterior: "",
                title: "08. INCOTERMS",
                icon: "arrow_right",
                url: "/apendices/40",
                id_grupo: 7
            },
           

        ],
        subgrupos: [],
        /*    [
               {id:5, nombre: "Activo Fijo", icon:"domain", trafico:0,
                   grupo: 2, //Grupo al que pertenece este subgrupo
               },
           ], */
        itemssubgrupo: [],
        /*     [{
                    nombre_anterior: "27. Identificadores Activo Fijo",
                    title: "Identificadores Activo Fijo",
                    icon: "arrow_right",
                    url: "/apendices/27",
                    id_grupo: 5,
                    grupo: 2, //Grupo princiapl al que pertenece este item de subgrupo
                },
            ], */

        url_active: location.href,

    }),
    computed: {
        view_trafico() {
            return this.$store.state.trafico;
        },
        sa31() {
           
             return this.$store.state.sa31;
        },
        mve() {
           
             return this.$store.state.emanifiesto;
        }
    },
    components: {},
    methods: {
        render(url) {
            this.$router.push(url);
        },
        filtrarApendices: function () {
            if (this.busqueda != "") {
                this.itemsOrdered = this.items.filter(item => {
                    return item.title.toString().toLowerCase().search(this.busqueda.toString().toLowerCase()) != -1;
                });
            } else {
                this.ordenar();
            }
        },
        getItemsGrupo: function (idGrupo) {
            var filtro = this.items.filter(function (item) {
                return item.id_grupo == idGrupo;
            });
            return filtro;
        },
        getItemsSubgrupo: function (idGrupo) {
            var filtro = this.itemssubgrupo.filter(function (item) {
                return item.id_grupo == idGrupo;
            });
            return filtro;
        },
        ordenar: function () {
            this.itemsOrdered = this.items.sort(function (a, b) {
                if (a.title > b.title) {
                    return 1;
                }
                if (a.title < b.title) {
                    return -1;
                }
                return 0;
            });
        },
        setGrupo: function () {
            try {
                if (this.$store.state.trafico == 1)
                    this.traficoActivo = 1;
                else if (this.$local_storage.get("id_cliente") == 0)
                    this.traficoActivo = 1;
                else
                    this.traficoActivo = 0;

                var thisObj = this;
                var activo = this.items.filter(function (item) {
                    return thisObj.url_active.indexOf(item.url) != -1;
                });
                var activoSubgrupos = this.itemssubgrupo.filter(function (item) {
                    return thisObj.url_active.indexOf(item.url) != -1;
                });

                if (activo.length > 0) {
                    this.grupoActivo = activo[0].id_grupo;
                } else if (activoSubgrupos.length > 0) {
                    this.grupoActivo = activoSubgrupos[0].grupo;
                    this.subgrupoActivo = activoSubgrupos[0].id_grupo;
                } else {
                    this.grupoActivo = 1; //Default 1
                }

            } catch (error) {
                console.log(error);
            }

        },
    }, //methods
    created: function () {
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
            this.items.push({
                nombre_anterior: "",
                title: "Agentes Aduanales Generales",
                icon: "arrow_right",
                url: "/apendices/ap_agentes_admin",
                id_grupo: 1
            });
        }
        if (this.$local_storage.get("id_cliente") > 0) {
            this.items.push({
                nombre_anterior: "28. Palabras Clave Activo Fijo",
                title: "Palabras Clave Activo Fijo",
                icon: "arrow_right",
                url: "/apendices/28",
                id_grupo: 5, //Grupo princiapl al que pertenece este item de subgrupo
            });
        }
        this.ordenar();
        this.setGrupo();
    },

};
</script>

<style  scoped>

</style>
